var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":this.maxWidth},model:{value:(_vm.isShowing),callback:function ($$v) {_vm.isShowing=$$v},expression:"isShowing"}},[_c('payment-details-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }